import { Link } from "react-router-dom"
import type { KpiDefinition, KpiData } from "lib/kpi-registry"

interface DynamicKpiCardProps {
  definition: KpiDefinition
  data?: KpiData
  loading?: boolean
}

export function DynamicKpiCard({ definition, data, loading }: DynamicKpiCardProps) {
  const Icon = definition.icon
  const value = data?.value ?? 0
  const subtitle = data?.subtitle
  const subtitleColor = data?.subtitleColor || "var(--hexa-text-muted)"

  const cardStyle: React.CSSProperties = {
    backgroundColor: "var(--hexa-card-bg)",
    border: definition.isPlugin
      ? "1px dashed rgba(123, 63, 255, 0.4)"
      : "1px solid var(--hexa-border)",
    borderRadius: 8,
    padding: "12px 14px",
  }

  const content = (
    <>
      <div className="flex items-center gap-1.5 mb-1">
        <Icon
          width={13}
          height={13}
          style={{ color: definition.colorAccent }}
        />
        <span
          className="truncate"
          style={{ fontSize: 11, color: "var(--hexa-text-muted)" }}
        >
          {definition.label}
        </span>
      </div>
      <div
        className="tabular leading-none"
        style={{
          fontSize: 24,
          fontWeight: 500,
          color: "var(--hexa-text-primary)",
        }}
      >
        {loading ? "—" : value}
      </div>
      {subtitle && (
        <div
          className="truncate mt-1"
          style={{ fontSize: 11, color: subtitleColor }}
        >
          {subtitle}
        </div>
      )}
    </>
  )

  return (
    <Link
      to={definition.linkTo}
      className="flex flex-col transition-all hover:scale-[1.02] cursor-pointer"
      style={cardStyle}
    >
      {content}
    </Link>
  )
}
